// Tanner Fry
// dev.lasutriv@gmail.com
// Component used for creating a trask for the task tracker.

import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCorrectDomain } from '../../../AppSettings';
import { CustomPasswordField } from '../inputs/CommonInputs';
import { trackUserRegistration } from '../../../utils/analytics';

// The base widget that builds the entire widget via other components.
function RegisterForm(props) {  
    const navigate = useNavigate();
    const [isCheckingFormErrorPlacement, setIsCheckingFormErrorPlacement] = useState(false);
    const [registerError, setRegisterError] = useState('');

    // Only allow registration on localhost
    useEffect(() => {
        if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
            navigate('/login');
            return;
        }
        setIsCheckingFormErrorPlacement(true);
    }, [navigate])

    useEffect(() => {
        // Get form error element and change position
        let formErrorElements = document.getElementsByClassName('form-error');
        if (formErrorElements.length > 0) {
            // Loop
            for (let i = 0; i < formErrorElements.length; i++) {
                // Get form error element's width
                let formErrorElementWidth = formErrorElements[i].clientWidth;
                // Set form error element's left position
                let formErrorStyle = 'left: -' + (10 + formErrorElementWidth) + 'px;';
                // Set form error element's style
                formErrorElements[i].setAttribute('style', formErrorStyle);
            }
            console.log("formErrorElements: ", formErrorElements);
            
        }

        setIsCheckingFormErrorPlacement(false);
    }, [isCheckingFormErrorPlacement])

    async function submitForm(values, setSubmitting) {
        setRegisterError('');

        try {
            const response = await fetch(getCorrectDomain() + '/api/users/add', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: values.email,
                    passHash: values.pass,
                    firstName: values.firstName,
                    lastName: values.lastName,
                })
            });

            const responseJson = await response.json().catch(() => null);

            if (!response.ok) {
                const apiError = responseJson?.error || 'Unable to create account right now.';
                setRegisterError(apiError);
                setSubmitting(false);
                return;
            }

            trackUserRegistration();
            console.log(JSON.stringify(responseJson));
            navigate('/login');
            setSubmitting(false);
        } catch (error) {
            console.warn('Something went wrong.', error);
            setRegisterError('Unable to reach the server. Please try again.');
            setSubmitting(false);
        }
    }

    function resetForm() {
        
    }

    function handleLoginClick() {
        navigate('/login');
    }

    return (
        <div className='form-container-login-register'>
            <Formik
                initialValues={ { email: '', pass: '', firstName: '', lastName: '' } }
                validate={ values => {
                    setIsCheckingFormErrorPlacement(true);
                    const errors: Partial<{email, pass, firstName, lastName}> = {};
                    
                    if (!values.email) {
                        errors.email = 'Required';
                    } else if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/i.test(values.email)) {
                        errors.email = 'Invalid email address';
                    }
                    if (!values.pass) {
                        errors.pass = 'Required'
                    }
                    if (!values.firstName) {
                        errors.firstName = 'Required';
                    }
                    if (!values.lastName) {
                        errors.lastName = 'Required';
                    }

                    return errors;
                }}
                onSubmit={ (values, { setSubmitting }) => {
                    console.log("Register form values: ", values);
                    submitForm(values, setSubmitting);
                }}
                onReset={ (values) => {
                    resetForm();
                }}
            >
                { ({ isSubmitting }) => (
                    <Form>
                        <h2>Register</h2>
                        <div className='form-group-inputs'>
                            <div className='field-group'>
                                {/* <div className='form-field-title'>Email<div className='required-asterisk'>*</div></div> */}
                                <Field type="email" name='email' placeholder="Email" as='input' autoFocus autoComplete="username" />
                                <ErrorMessage name='email' component='div' className='form-error' />
                            </div>
                            <div className='field-group'>
                                {/* <div className='form-field-title'>Password<div className='required-asterisk'>*</div></div> */}
                                <Field as={CustomPasswordField} name="pass" placeholder="Password" autoComplete="new-password" />
                                <ErrorMessage name='pass' component='div' className='form-error' />
                            </div>
                            <div className='field-group'>
                                {/* <div className='form-field-title'>First Name<div className='required-asterisk'>*</div></div> */}
                                <Field name='firstName' placeholder='First name' as='input' />
                                <ErrorMessage name='firstName' component='div' className='form-error' />
                            </div>
                            <div className='field-group'>
                                {/* <div className='form-field-title'>Last Name<div className='required-asterisk'>*</div></div> */}
                                <Field name='lastName' placeholder='Last name' as='input' />
                                <ErrorMessage name='lastName' component='div' className='form-error' />
                            </div>
                        </div>
                        <hr />
                        <div className='button-group'>
                            <button type='reset'>Cancel</button>
                            <button id='create-btn' type='submit' disabled={ isSubmitting }>Create</button>
                            <button id='login-btn' type='button' onClick={ handleLoginClick }>Login</button>
                        </div>
                        {registerError && (
                            <div className='error-message with-background'>{registerError}</div>
                        )}
                    </Form>
                )}
            </Formik>
        </div>
    );
}


export default RegisterForm;